import $ from 'jquery';

$(function () {
    const form = $('.multisearch-form');
    const iconButton = $('.icon-link');

    if (iconButton.length > 0) {
        iconButton.on('click', function () {
            $(this).parents('.multisearch-form').submit();
        });
    }

    if (form.length > 0) {
        form.on('submit', function (e) {
            e.preventDefault();

            const params = form.serializeArray();

            const type = params.find(el => el.name == 'searchLocation').value;
            const s = params.find(el => el.name == 's').value;

            if (type == 'catalog') {
                window.location = `https://cml.bibliocommons.com/v2/search?${new URLSearchParams({query: s}).toString()}`;
            } else if (type == 'articles') {
                const articlesParams = new URLSearchParams({
                    authtype: 'ip,guest',
                    direct: 'true',
                    site: 'eds-live',
                    scope: 'site',
                    type: '0',
                    custid: 'columbus',
                    groupid: 'main',
                    profid: 'eds',
                    mode: 'bool',
                    lang: 'en',
                    cli0: 'FT',
                    clv0: 'Y',
                    cli1: 'DISCIPLINE',
                    clv1: '',
                    bquery: s,
                });

                window.location = `https://search.ebscohost.com/login.aspx?${articlesParams.toString()}`;

            } else if (type == 'events') {
                const dateObj = new Date();
                const start = dateObj.toISOString().substr(0,10);
                dateObj.setDate(dateObj.getDate() + 180);
                const end = dateObj.toISOString().substr(0,10);

                const eventsParams = new URLSearchParams({
                    term: s,
                    start,
                    end,
                });

                window.location = `https://events.columbuslibrary.org/events?${eventsParams.toString()}`;
            } else {
                let searchLocation = type;
                window.location = window.location.origin + `?searchLocation=${type}&${new URLSearchParams({s}).toString()}`;
            }
        });
    }
});
